export const data = {
    gmapstyle: [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ebe3cd"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#523735"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#f5f1e6"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#c9b2a6"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#dcd2be"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#ae9e90"
            }
          ]
        },
        {
          "featureType": "landscape.natural",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dfd2ae"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dfd2ae"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#93817c"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#a5b076"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#447530"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f1e6"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#fdfcf8"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f8c967"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#e9bc62"
            }
          ]
        },
        {
          "featureType": "road.highway.controlled_access",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e98d58"
            }
          ]
        },
        {
          "featureType": "road.highway.controlled_access",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#db8555"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#806b63"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dfd2ae"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#8f7d77"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#ebe3cd"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dfd2ae"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#78d1d3"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#92998d"
            }
          ]
        }
    ],    
    categories: [
        { 
            name: "Tasty pursuits",
            slug: "foodie",
            info: "Food and art are best friends that have made a home in Macao; a place that transcends a dining experience to create a culture quite apart from anywhere else in the world. By Matthew Keegan"
        },
        { 
            name: "Insta picks",
            slug: "instagrammable",
            info: "Get your camera ready for 10 most Insta-ready destinations in Macau – covering everything from food to parks, graffiti to architecture, and all the bright lights and big city attractions. By Matthew Keegan"
        },
        { 
            name: "Off the beaten path ",
            slug: "off",
            info: "Off the city centre or far out in the countryside, here are Macao’s hidden gems often overlooked by tourists, brought into the limelight for you to explore. By Matthew Keegan"
        },
        { 
            name: "Cultural explorer",
            slug: "cultural",
            info: "There is more to Macao’s claim to Unesco fame than the beautiful historical buildings – listen to fascinating stories behind these sites to find out why the city and its brilliant people are unique. By Jason Wordie"
        },
    ],
    spots: [{
		"category": "foodie",
            "name": "Riquexo",
            "info": "<p>For a taste of authentic Macanese cuisine – itself a unique mix of Portuguese and Chinese ingredients that is only available in Macau – look no further than this family-owned restaurant run by 104-year-old Aida de Jesus, dubbed the godmother of Macanese cuisine, and her daughter Sonia Palmer. A favourite for more than 35 years, the dishes here are honed to a fine art and include classics such as the ground-beef dish minchi, African chicken and porco bafassa (pork with turmeric sauce). With its walls adorned with images of a Macao long gone, it’s here that the soul of old Macau lives on. A must visit.</p><p>Riquexo, Songbo Village, 69 Av. de Sidónio Pais, +853 2856 5655</p>",
            "position": {
                "lat": 22.202807,
                "lng": 113.552033
            },
            "article": "none",
            "slug": "riquexo",
            "photos": {
                "url": "riquexo.jpg"
            }
        },
        {
            "category": "foodie",
            "name": "The 8 Restaurant",
            "info": "<p>Macao’s first-and-only Chinese restaurant to be awarded three Michelin stars, The 8 Restaurant serves up some of the finest Cantonese cuisine with a signature creative touch. Visit during the lunchtime session where diners can choose from more than 40 kinds of artfully created dim sum. Among them, goldfish-shaped shrimp dumplings, hedgehog char siu bun, crab-shaped baked tartlets or river shrimp dumplings coated in puff pastry in the shape of a purse.</p><p>The lavish Alan Chan-designed space is also a work of art. Wine lovers will be spoilt for choice with the phenomenal wine cellar that boasts more than 17,000 labels.</p><p>The 8 Restaurant, Grand Lisboa, Av. de Lisboa, +853 8803 7788</p>",
            "position": {
                "lat": 22.191204,
                "lng": 113.543577
            },
            "article": "https://www.scmp.com/magazines/100-top-tables/article/2136364/8-restaurant-showcases-aquatic-pleasures-cantonese-and",
            "slug": "the_eight_grand_lisboa",
            "photos": {
                "url": "the_eight_grand_lisboa.jpg"
            }
        },
        {
            "category": "foodie",
            "name": "The Golden Peacock",
            "info": "<p>For show-stopping Indian cuisine, look no further than The Golden Peacock. Awarded a Michelin star, head chef Justin Paul’s creative flair shines in the exquisite presentation of his dishes, which taste as good as they look. Highlights include the tandoori platter, Kashmiri lamb with chicken in yellow lentil, and the lychee sorbet and beautiful petit four chocolates. The vegetarian selection is equally varied and delicious. The lunchtime buffet is one of the best value-for-money spreads in Macao, offering a diverse range of excellent curries and chaat, or savoury snacks.</p><p>The Golden Peacock, The Venetian Macao, Estrada da Baía de Nossa Senhora da Esperança, Shop 1037, +853 8118 9696</p>",
            "position": {
                "lat": 22.147655,
                "lng": 113.55984
            },
            "article": "https://www.scmp.com/magazines/good-eating/article/1924658/authenticspice-mix-golden-peacock-venetian-macao-resort-hotel",
            "slug": "the_golden_peacock_venetian_macao",
            "photos": {
                "url": "the_golden_peacock_venetian_macao.jpg"
            }
        },
        {
            "category": "foodie",
            "name": "Lai Heen",
            "info": "<p>Located on the 51st floor of The Ritz-Carlton, Macau, Lai Heen is the highest Chinese restaurant in the city and offers some of its most elevated Cantonese fare. Don’t miss signature dishes including the melt-in-the-mouth barbecued Iberico pork in honey sauce or the deep-fried codfish fillet with crispy garlic.</p><p>The artistry of the cuisine is matched by the stylish interiors with subtle nods to Macau’s Chinese and Portuguese heritage. The restaurant offers five private dining rooms with spectacular views.</p><p>Lai Heen, 51/F, The Ritz-Carlton, Macau, Estrada da Baía de Nossa Senhora da Esperança, +853 8886 6712</p>",
            "position": {
                "lat": 22.146692,
                "lng": 113.554749
            },
            "article": "https://www.scmp.com/magazines/style/article/2119826/ritz-carltons-lai-heen-restaurant-offers-some-most-authentic",
            "slug": "lai_heen_galaxy",
            "photos": {
                "url": "lai_heen_galaxy.jpg"
            }
        },
        {
            "category": "foodie",
            "name": "SW Steakhouse",
            "info": "<p>Outstanding food and entertainment are on the menu here. While you tuck in to a prime steak or some of the freshest seafood from around Asia, you’ll be enthralled by a theatrical show that magically appears in the centre of the room every 30 minutes. In total, a series of six 3D shows of between two and three-minutes blend computer animation, puppetry and animatronics to keep you entertained. Meanwhile, the tantalising food will equally ensure you enjoy a memorable meal </p><p>SW Steakhouse, Wynn Palace, Macau, Av. da Nave Desportiva, +853 8889 3663</p>",
            "position": {
                "lat": 22.147771,
                "lng": 113.571191
            },
            "article": "https://www.scmp.com/magazines/100-top-tables/article/2135461/sw-steakhouse-features-delectable-appetisers-and-fine-steak",
            "slug": "sw_steakhouse_wynn_palace",
            "photos": {
                "url": "sw_steakhouse_wynn_palace.jpg"
            }
        },
        {
            "category": "foodie",
            "name": "8½ Otto e Mezzo Bombana",
            "info": "<p>In this outlet of renowned Italian chef Umberto Bombana they say the art of the kitchen meets the art of design. His approach has won them a Michelin star. Highlights include the linguini with Hokkaido sea urchin, the homemade tagliolini and Mayura M9 sirloin. Italian cuisine at its finest. The restaurant is committed to using only the freshest seasonal ingredients and the menu evolves to meet that pledge. Dining here is a culinary journey.</p><p>Bombana, Galaxy Macau, Estrada da Baía de Nossa Senhora da Esperança,  +853 8886 2169</p>",
            "position": {
                "lat": 22.146751,
                "lng": 113.555338
            },
            "article": "https://www.scmp.com/magazines/48-hours/article/1834198/restaurant-review-8-12-otto-e-mezzo-bombana-macau-truly-great",
            "slug": "8½_otto_e_mezzo_bombana",
            "photos": {
                "url": "812_otto_e_mezzo_bombana.jpg"
            }
        },
        {
            "category": "foodie",
            "name": "António",
            "info": "<p>This venerable Portuguese restaurant is always busy, in large part due to its charismatic owner and chef Antonio Neves Coelho who is full of life and passion for his cooking. Try the popular clam dish; the clams are caught freshly in Macau and cooked with Portuguese wine, shallots, coriander, some lemon juice and a lot of love. A side of bread is perfect for soaking up the delicious sauce. You step in António’s and it’s like stepping into Portugal. The Fado music, relaxing atmosphere, the food, and chef Antonio’s hospitality. For a relaxing lunch or dinner, this is the perfect spot.</p><p>António, Rua dos Clerigos No. 7, Old Taipa Village, +853 2899 9998</p>",
            "position": {
                "lat": 22.152946,
                "lng": 113.556514
            },
            "article": "https://www.scmp.com/lifestyle/food-drink/article/2176701/how-ex-portuguese-soldier-learned-cook-and-now-owns-michelin",
            "slug": "antonio",
            "photos": {
                "url": "antonio.jpg"
            }
        },
        {
            "category": "foodie",
            "name": "Alain Ducasse at Morpheus",
            "info": "<p>With the legendary French chef, food is art here; art is food. Awarded two Michelin stars within six months of opening at Morpheus, City of Dreams, diners can enjoy celebrated signature dishes like the Mediterranean gamberoni, delicate gelée and gold caviar or the farm veal chop, truffle Matignon and artisanal pasta. Alongside the exquisite food, the decor is also a visual stunner. The dining room is a veritable wonderland of 619 Lasvit-designed hanging crystal chandeliers (meant to resemble a waterfall of light descending from the ceiling) that shimmer and glitter in the plush space. Dining here is a truly decadent experience.</p><p>Alain Ducasse at Morpheus, Level 3, Morpheus City of Dreams, Estr. do Istmo, +853 8868 3432</p>",
            "position": {
                "lat": 22.150061,
                "lng": 113.566927
            },
            "article": "https://www.scmp.com/magazines/style/travel-food/article/2156727/michelin-maestro-and-picasso-pastry-make-morpheus-dream",
            "slug": "alain_ducasse_at_morpheus",
            "photos": {
                "url": "alain_ducasse_at_morpheus.jpg"
            }
        },
        {
            "category": "foodie",
            "name": "La Famiglia",
            "info": "<p>Located in heart of Taipa Village – one of the city’s best-preserved areas – at La Famiglia you can feast on beautifully presented and deliciously tasty Macanese dishes from renowned Macanese chef Florita de Alves. Standout dishes include Macau chicken, a braised chicken stew with coconut milk, shredded coconut and turmeric; capela, a Macanese meatloaf; and fried shrimp with garlic butter sauce. This convivial, family-run, restaurant offers a comfortable and welcoming environment for diners to sample authentic Macanese flavours.</p><p>La Famiglia, Rua dos Clerigos No.76, Taipa, +853 2857 6131</p>",
            "position": {
                "lat": 22.15324,
                "lng": 113.556957
            },
            "article": "none",
            "slug": "la_famiglia",
            "photos": {
                "url": "la_famiglia.jpg"
            }
        },
        {
            "category": "foodie",
            "name": "Aji",
            "info": "<p>Aji offers an artistic fusion of Peruvian and Japanese flavours at Macau’s first restaurant to showcase unique Nikkei cuisine. The menu was designed by celebrity chef Mitsuharu Tsumura of the Maido restaurant in Lima, ranked No10 in the World’s 50 Best Restaurants 2019. Here dishes dazzle both the eyes and the taste buds and the fusion of flavours pack a punch. Signature dishes such as Peruvian Nikkei sushi land and sea – where you watch the beef sushi being torched right in front of you – are a standout. You can’t miss the northern ceviche either. Wash it down with a tipple or two from the restaurant’s pisco and sake bar that offers some of the best Peruvian-inspired cocktails outside of Lima.</p><p>Aji, MGM Cotai, Avenida da Nave Desportiva, +853 8806 2308</p>",
            "position": {
                "lat": 22.145736,
                "lng": 113.568084
            },
            "article": "https://www.scmp.com/magazines/good-eating/article/2141024/if-looks-could-thrill-ajis-nikkei-fare-tastes-good-it-looks",
            "slug": "aji_mgm_cotai",
            "photos": {
                "url": "aji_mgm_cotai.jpg"
            }
        },
        {
            "category": "instagrammable",
            "name": "Alto de coloane",
            "info": "<p>At 172.4 metres above sea level, Alto de Coloane or Coloane Peak is the highest point in Macao, offering stunning views across green hills, forests and the South China Sea. You could follow the 8-km-long Coloane Hiking Trail to the summit. En route to the top you pass the equally Instagrammable A-Ma Cultural Village and the world’s tallest statue of the Chinese sea goddess A-Ma. Take a break at the picnic area at the top.</p><h6 class='credits'>(Photo: António Leong)</h6>",
            "position": {
                "lat": 22.120989,
                "lng": 113.561432
            },
            "article": "https://www.scmp.com/destination-macau/article/1936167/discover-macau-weekend-coloane",
            "slug": "alto_de_coloane",
            "photos": {
                "url": "alto_de_coloane.jpg"
            }
        },
        {
            "category": "instagrammable",
            "name": "Travessa da Paixão",
            "info": "<p>This small lane just a stone’s throw away from Ruins of St Paul’s means Love Lane in Portuguese. With its pink and yellow European-style buildings, it certainly has a romantic feel to it. Spend time here to feel like you’ve been transported to Lisbon. It’s not hard to see why the camera loves this spot.</p>",
            "position": {
                "lat": 22.197131,
                "lng": 113.540401
            },
            "article": "none",
            "slug": "travessa_da_paixao",
            "photos": {
                "url": "travessa_da_paixao.jpg"
            }
        },
        {
            "category": "instagrammable",
            "name": "St Lazarus District",
            "info": "<p>Home to some of Macao’s prettiest and most colourful streets, St Lazarus District is quite possibly the city's most Instagrammable and charming neighbourhood. Here you’ll find colourful colonial buildings, narrow lanes lined with Portuguese-style cobblestone and ample photo ops. The distinctive red and yellow Tap Seac Gallery (the home to many free art exhibitions) is among the standouts.</p>",
            "position": {
                "lat": 22.197368,
                "lng": 113.545343
            },
            "article": "none",
            "slug": "st_lazarus_district",
            "photos": {
                "url": "st_lazarus_district.jpg"
            }
        },
        {
            "category": "instagrammable",
            "name": "Guia Hill",
            "info": "<p>Ride the cable car to Guia Hill for panoramic views. It’s here where you’ll also find one of Macao’s top attractions, the Guia Fortress. Constructed in the early 1600s, the fortress features a fort, chapel and adjacent lighthouse. The lighthouse, built in 1864, was the first Western-style lighthouse on the China coast. From the foot of the hill at Flora Garden to the top, the cable car lasts for 80 seconds.</p>",
            "position": {
                "lat": 22.196474,
                "lng": 113.549724
            },
            "article": "none",
            "slug": "guia_hill",
            "photos": {
                "url": "guia_hill.jpg"
            }
        },
        {
            "category": "instagrammable",
            "name": "Penha Hill",
            "info": "<p>Standing more than 60 metres above sea level, Penha Hill is photo-worthy for its splendid views looking out towards Macau Tower and the harbour. The beautiful Chapel of Our Lady of Penha is located on top of the hill. Surrounded by trees and flowered paths, the chapel is a popular site for wedding photos and a frequent backdrop in television and movie productions. It’s picture perfect.</p>",
            "position": {
                "lat": 22.186428,
                "lng": 113.534701
            },
            "article": "none",
            "slug": "penha_hill",
            "photos": {
                "url": "penha_hill.jpg"
            }
        },
        {
            "category": "instagrammable",
            "name": "Anim’Arte Nam Van",
            "info": "<p>Already an attractive waterfront area, Nam Van Lake’s newest leisure and entertainment landmark are the graffiti murals at Anim’Arte Nam Van. Since 2016, artists have exhibited here and the walls are frequently updated. With benches near the murals, you can sit, relax and take in the artwork as you grab a snapshot of the city’s culture of street art. Any photo here is sure to brighten up your Instagram feed.</p><h6 class='credits'>(Photo: Joshua Lee)</h6>",
            "position": {
                "lat": 22.189517,
                "lng": 113.538787
            },
            "article": "https://www.scmp.com/native/lifestyle/topics/experience-macao/article/2107572/young-art-macaus-arts-scene-gets-burst",
            "slug": "graffiti_walls_at_animarte_nam_van",
            "photos": {
                "url": "graffiti_walls_at_animarte_nam_van.jpg"
            }
        },
        {
            "category": "instagrammable",
            "name": "Rua da Felicidade",
            "info": "<p>Rua da Felicidade, or “Happiness Street” used to be the epicentre of Macao’s gaming industry in the 19th century and all of the vices that came with it. Today, the street has cleaned up its act and it is home to quaint shops and eateries that serve up some of the best food in town. With Chinese shutters painted red on each of the shops, the architecture is beautifully preserved and recreates the look of the area in the early 19th century. This is the ideal place to take a stroll with a camera.</p><h6 class='credits'>(Photo: Chintung Lee / Shutterstock.com)</h6>",
            "position": {
                "lat": 22.19447,
                "lng": 113.537623
            },
            "article": "none",
            "slug": "rua_da_felicidade",
            "photos": {
                "url": "rua_da_felicidade.jpg"
            }
        },
        {
            "category": "instagrammable",
            "name": "The Holy House of Mercy Museum",
            "info": "<p>Located in the heart of Macao’s colourful town square – Senado Square – is the Holy House of Mercy. Built in 1569, over the years it’s served as an orphanage for girls and a public health clinic. Today, it’s a three-gallery museum filled with religious artefacts, porcelain and other items.</p><p>The hidden gem is the view from the second-floor balcony, which overlooks Senado Square. This is one of the very best views of the square’s pastel-coloured buildings and Portuguese black-and-white cobblestone paving. The view from the balcony is worth the MOP5 per person entry fee.</p>",
            "position": {
                "lat": 22.193763,
                "lng": 113.540201
            },
            "article": "none",
            "slug": "the_museum_of_the_holy_house_of_mercy_of_macau",
            "photos": {
                "url": "the_museum_of_the_holy_house_of_mercy_of_macau.jpg"
            }
        },
        {
            "category": "instagrammable",
            "name": "Ruins of St. Paul’s",
            "info": "<p>As Macao’s most visited and iconic attraction, no trip to Macao is complete without a photo at the Ruins of St. Paul’s. For an alternative view, a steel stairway at the rear of the facade allows visitors to climb up to a viewing platform where you can get a closer look at the stone carvings and enjoy views looking overlooking the surrounding area and historic centre of Macao.</p>",
            "position": {
                "lat": 22.197701,
                "lng": 113.540843
            },
            "article": "https://www.scmp.com/destination-macau/article/1939555/secrets-st-pauls-story-behind-macaus-most-famous-landmark",
            "slug": "at_the_top_of_ruins_of_st_pauls",
            "photos": {
                "url": "at_the_top_of_ruins_of_st_pauls.jpg"
            }
        },
        {
            "category": "instagrammable",
            "name": "Cotai Strip",
            "info": "<p>You can’t miss the razzle-dazzle of Macao’s main casino strip. Home to some of the most extravagant casino buildings in the world, the main street is best viewed at night when it transforms into a picture-postcard scene of glittering lights and distinctive neon. Great vantage points can be gained from atop the replica Eiffel Tower at The Parisian Macao or the Golden Reel, a 130-metre-high Ferris wheel at Studio City.</p><h6 class='credits'>(Photo: psgxxx / Shutterstock.com)</h6>",
            "position": {
                "lat": 22.143623,
                "lng": 113.562277
            },
            "article": "none",
            "slug": "cotai_strip",
            "photos": {
                "url": "cotai_strip.jpg"
            }
        },
        {
            "category": "cultural",
            "name": "Moorish Barracks",
            "info": "<p>Distinctive, Islamic-influenced architecture is one of Macao’s astonishing highlights. O Quartel dos Mouros, The Moorish Barracks, was once a prominent hillside feature seen by ships entering or leaving the Inner Harbour but is now tucked away behind surrounding buildings.This lemon-coloured, Moroccan-flavoured masterpiece was designed by the Italian architect Cassuso and completed in August 1874, before a typhoon devastated the rest of the city the following month. A contingent of police mainly recruited from Goa in Western India were based there from its opening until the late 1950s. Now used by the city’s port authority, the building’s exterior lighting features anchor designs.</p><h6 class='credits'>(Photo: Kit Leong / Shutterstock.com)</h6>",
            "position": {
                "lat": 22.18744,
                "lng": 113.532605
            },
            "article": "https://www.scmp.com/native/lifestyle/topics/experience-macau/article/1848586/step-senado-square-and-past-walking-tours",
            "slug": "moorish_barracks",
            "photos": {
                "url": "moorish_barracks.jpg"
            }
        },
        {
            "category": "cultural",
            "name": "Iec Long Fireworks Factory",
            "info": "<p>Making firecrackers was once a mainstay of the local economy among other “dangerous” industries. Given the explosive and flammable nature of the work, the factories had to be located in remote spots away from residents to minimise risks. Taipa was home to several factories until the 1970s and one of the biggest, Fábrica de Panchões Iec Long, has recently been opened as a heritage site. Tour the workshops and see the berms constructed in case of explosions that would direct any blast upwards rather than outwards. As well as firecrackers, skyrockets and other pyrotechnics for export, the factories produced safety matches.</p>",
            "position": {
                "lat": 22.154871,
                "lng": 113.557861
            },
            "article": "https://www.scmp.com/destination-macau/article/2017666/fireworks-art-take-centre-stage-macau-international-fireworks",
            "slug": "firecracker_factories",
            "photos": {
                "url": "firecracker_factories.jpg"
            }
        },
        {
            "category": "cultural",
            "name": "Old Protestant Cemetery",
            "info": "<p>Established by the East India Company in 1821, the cemetery in the grounds of the neighbouring Casa Garden mansion contains historic graves and numerous trees that provide botanical connections to Southeast Asia.The widespread custom of planting frangipani trees in graveyards was a practice brought to Macao from Malacca by 17th century Portuguese settlers, where it was a practice in Malay communities. The gnarled, still-healthy specimens found here are more than a hundred years old.</p><p>The trees shade the weathered headstones with their fascinating inscriptions. The cemetery is the resting place of numerous prominent figures, including Swedish trader and historian Anders Ljungstedt, British artist George Chinnery, and the missionary and Chinese translator Robert Morrison.</p><h6 class='credits'>(Photo: e X p o s e / Shutterstock.com)</h6>",
            "position": {
                "lat": 22.199763,
                "lng": 113.539806
            },
            "article": "none",
            "slug": "east_india_company_cemetery_old_protestant_cemetery",
            "photos": {
                "url": "east_india_company_cemetery_old_protestant_cemetery.jpg"
            }
        },
        {
            "category": "cultural",
            "name": "Barrier Gate",
            "info": "<p>Now completely overshadowed by the enormous Gongbei Port of Entry customs and immigration checkpoint, the yellow-painted Barrier Gate once marked the frontier between Macao and mainland China. This structure dates from 1870, though much earlier customs posts and gates existed. The first formal crossing was inaugurated in 1573.</p><p>The site has deep historical significance. In August 1849, Portuguese Governor João Ferreira do Amaral was assassinated here by Chinese bandits, which sparked an armed confrontation led by Vicente Nicolau de Mesquita, a Macanese army officer.            </p><p>From the 1950s to the 1980s, the Barrier Gate offered tourists a fleeting glimpse of then-forbidden Red China and dramatic descriptions featured in every tourist guidebook of the period.</p><h6 class='credits'>(Photo: Kit Leong / Shutterstock.com)</h6>",
            "position": {
                "lat": 22.215957,
                "lng": 113.549112
            },
            "article": "none",
            "slug": "barrier_gate",
            "photos": {
                "url": "barrier_gate.jpg"
            }
        },
        {
            "category": "cultural",
            "name": "Va Kio Yat Po",
            "info": "<p>The Jornal Va Kio, or “Overseas Chinese Journal”, was established in 1937 and is the oldest Chinese-language publication still operating in Macao. A section of the old newspaper office has been preserved at the corner of Rua da Alfândega and Rua Ponte e Horta, where newer premises have been built behind.</p><p>Macao has a tradition of producing newspapers and periodicals in Portuguese and Chinese, which cover many different viewpoints. The Jornal Va Kio is a reminder that Macao has a historical role as a place where rival groups could meet and exchange ideas.</p><h6 class='credits'>(Photo: Chintung Lee / Shutterstock.com)</h6>",
            "position": {
                "lat": 22.193158,
                "lng": 113.537332
            },
            "article": "none",
            "slug": "va_kio_yat_po_offices",
            "photos": {
                "url": "va_kio_yat_po_offices.jpg"
            }
        },
        {
            "category": "cultural",
            "name": "Lou Lim Ieoc Garden",
            "info": "<p>Built in the early 1920s as the private pleasure garden of the prominent Lou business family, the grounds opened to the public in the 1950s. These extraordinary gardens brought the horticultural design of Central China to Macao, with ornamental ponds, meandering eight-fold paths, lotus ponds and miniature mountains.</p><p>The yellow summerhouse, surrounded by water and pleasingly combining Chinese and classical European architectural motifs, is occasionally used for art exhibitions, cultural performances and diplomatic receptions. A Chinese pavilion near the entrance gate is used by amateur musical groups as a rehearsal space. The sizeable peppermint green house glimpsed through the fence was once the family’s home and is now used by the Pui Ching Middle School.</p><h6 class='credits'>(Photo: Luoxi / Shutterstock.com)</h6>",
            "position": {
                "lat": 22.200399,
                "lng": 113.547378
            },
            "article": "none",
            "slug": "lou_lim_ioc_gardens",
            "photos": {
                "url": "lou_lim_ioc_gardens.jpg"
            }
        },
        {
            "category": "cultural",
            "name": "“Amaral” Stone at Lin Fong Temple",
            "info": "<p>In front of the Lin Fong Temple, on a granite boulder, a carved Portuguese crest surmounted by a crown marks the spot of territorial claims marked out by Governor Amaral in the late 1840s; his over-enthusiastic enforcement of these was one of the reasons for his murder in 1849.</p><p>The temple was built in 1570 and substantially renovated in subsequent centuries. This building has a prominent, if short-lived, role in Chinese history. Imperial Commissioner Lin Zexu stayed here in 1839 while on a mission to suppress the trade in opium, his efforts contributing to the outbreak of war between Britain and the Qing Dynasty. Lin’s stay in Macao is commemorated with a statue and a small museum.</p><h6 class='credits'>(Photo: António Leong)</h6>",
            "position": {
                "lat": 22.209887,
                "lng": 113.547776
            },
            "article": "none",
            "slug": "amaral_stone_at_the_lin_fong_temple",
            "photos": {
                "url": "amaral_stone_at_the_lin_fong_temple.jpg"
            }
        },
        {
            "category": "cultural",
            "name": "Cineteatro Alegria",
            "info": "<p>The clean lines and functional, streamlined appearance of buildings inspired by the Art Deco and Art Moderne movements are among Macao’s most unexpected architectural legacies. They bear witness to the city’s steady economic growth and prosperity from the 1920s onwards.</p><p>Cineteatro Alegria, built in the 1930s, is one such example, tucked away in the northern San Kiu neighbourhood. Unlike other contemporary cinemas, such as the Apollo on Avenida da Almeida Ribeiro, which have been converted to other purposes, this cinema is still used for its original function. It is especially attractive at night, when the exterior lighting brings forth glimpses of a largely vanished era.</p><h6 class='credits'>(Photo: António Leong)</h6>",
            "position": {
                "lat": 22.20209,
                "lng": 113.542889
            },
            "article": "none",
            "slug": "cineteatro_alegria",
            "photos": {
                "url": "cineteatro_alegria.jpg"
            }
        },
        {
            "category": "cultural",
            "name": "Mong Ha Fort",
            "info": "<p>Tucked away in the northern part of Macao, the hilltop Mong Ha fort dates from 1849, although the structure that still stands today was rebuilt in the 1860s. While the city’s other fortifications were mostly built in the 1630s, during periods of international rivalry between the Portuguese and the Dutch, this battery provided a lookout post against possible hostilities from the north. Machine gun emplacements were added in 1925 and may still be seen. From the end of the 1940s until the Portuguese garrison was withdrawn from Macao in 1974, Mong Ha and the neighbouring barracks (now converted into the Pousada de Mong-Há tourism training hotel) housed soldiers from Angola and Mozambique.</p><h6 class='credits'>(Photo: Cherry-Hai / Shutterstock.com)</h6>",
            "position": {
                "lat": 22.207946,
                "lng": 113.547632
            },
            "article": "none",
            "slug": "mong_ha_fort",
            "photos": {
                "url": "mong_ha_fort.jpg"
            }
        },
        {
            "category": "cultural",
            "name": "Camões Garden",
            "info": "<p>Tucked away between two granite boulders in the hillside at Camões Garden is a bronze bust of Luís de Camões, the greatest Portuguese poet.</p><p>A long-standing legend maintained that the poet wrote at least part of his epic Os Lusíadas while living in the early settlement. It was said he wrote between the very rocks where his image now rests. Endlessly repeated by generations of tour guides, like any other colourful urban legend, this fanciful tale has been debunked.</p><p>Camões had left China long before the first Portuguese settlement in the Macao peninsula in 1556-57, however inscriptions from Os Lusiads can be found elsewhere in Macao.</p><h6 class='credits'>(Photo: e X p o s e / Shutterstock.com)</h6>",
            "position": {
                "lat": 22.19984,
                "lng": 113.5395
            },
            "article": "https://www.scmp.com/culture/article/2156005/why-chinas-friendship-portugal-signified-luis-de-camoes-poet-exiled-three",
            "slug": "camoens_grotto_",
            "photos": {
                "url": "camoens_grotto_.jpg"
            }
        },
        {
            "category": "off",
            "name": "Three Lamps District",
            "info": "<p>Located in the less-touristy northern area of the Macao Peninsula, Three Lamps District is known for its distinctive lamppost situated in the public area of Rotunda de Carlos da Maia. This lively market area is perfect if you’d like to experience a real Macao shopping area and hunt for a bargain. This is where locals come for something more affordable or an alternative to malls dominated by luxury stores. There are streets lined with stalls selling fresh fruit and vegetables, flowers, clothes, handicrafts and souvenirs, and there are lots of small eateries dotted around. The market is especially active during weekends.</p><h6 class='credits'>(Photo: António Leong)</h6>",
            "position": {
                "lat": 22.202891,
                "lng": 113.545808
            },
            "article": "none",
            "slug": "three_lamps_district",
            "photos": {
                "url": "three_lamps_district.jpg"
            }
        },
        {
            "category": "off",
            "name": "Pou Tai Temple",
            "info": "<p>A lesser-explored alternative to the busy A-Ma Temple, the Pou Tai Temple is the city’s biggest temple and possibly most picturesque. Classically designed, the ornate main pavilion is home to the biggest statue of Buddha in Macao – a bronze statue 5.4 metres tall and weighing about 6 tonnes.The temple is part of a functioning monastery with monks onsite. It’s home to a popular vegetarian restaurant with an extensive menu. The monks tend the vegetable plots that supply the restaurant.</p><h6 class='credits'>(Photo: António Leong)</h6>",
            "position": {
                "lat": 22.161389,
                "lng": 113.551626
            },
            "article": "none",
            "slug": "pou_tai_monastery_and_pou_tai_un_temple",
            "photos": {
                "url": "pou_tai_monastery_and_pou_tai_un_temple.jpg"
            }
        },
        {
            "category": "off",
            "name": "Macau Design Centre",
            "info": "<p>It’s tucked away down an alley in the former Hac Sa Wan industrial area, but the Macau Design Centre is worth seeking out. This five-storey, former factory has been transformed into a multi-functional space that houses exhibitions, shops and workshops. Among the highlights, the ground floor retail space stocks homewares and craft from more than 50 homegrown labels. There’s a bookstore, a cafe serving great coffee and a performance space. The remaining floors are home to an eclectic mix of design studios, workshops, exhibition spaces and there’s even a rooftop garden. For anyone interested in art and design it’s a gem.</p><h6 class='credits'>(Photo: António Leong)</h6>",
            "position": {
                "lat": 22.208445,
                "lng": 113.549148
            },
            "article": "none",
            "slug": "macau_design_centre",
            "photos": {
                "url": "macau_design_centre.jpg"
            }
        },
        {
            "category": "off",
            "name": "Macao Giant Panda Pavilion",
            "info": "<p>Located inside Macao’s biggest natural green area, Seac Pai Van Park in Coloane, the Macao Giant Panda Pavilion offers a rare chance to see giant pandas up close. The pavilion is home to two giant pandas, Kai Kai and Xin Xin, and their adorable twins. It’s also home to a couple of rare red pandas. The 3,000-square-metre, state-of-the-art facility comprises indoor activity quarters and an outdoor yard, as well as centres for the feeding and caring of the pandas. It’s well worth the visit and MOP10 entry fee.</p>",
            "position": {
                "lat": 22.126667,
                "lng": 113.558983
            },
            "article": "https://www.scmp.com/news/hong-kong/education/article/1982072/its-twins-macaus-giant-panda-xin-xin-delivers-two-cubs-45",
            "slug": "panda_pavilion",
            "photos": {
                "url": "panda_pavilion.jpg"
            }
        },
        {
            "category": "off",
            "name": "Hac Sa Reservoir Country Park",
            "info": "<p>Ideal for a family day, the facilities include a barbecue area, playground and pedal boats for hire. Around the reservoir are sign-posted trails that include a 45-minute family hike and a 90-minute path up to A-Ma Cultural Village. All in all, an ideal place for walks with family and friends, adventuring, splashing around in the water park and even grassy slope sliding. And it's free.</p>",
            "position": {
                "lat": 22.123981,
                "lng": 113.571205
            },
            "article": "https://www.scmp.com/native/lifestyle/topics/experience-macau/article/1842487/other-side-macau-fun-all-family-coloane",
            "slug": "hac_sa_reservoir_country_park",
            "photos": {
                "url": "hac_sa_reservoir_country_park.jpg"
            }
        },
        {
            "category": "off",
            "name": "A-Ma Cultural Village",
            "info": "<p>Perched on a mountaintop in Macau’s Coloane district, A-Ma Cultural Village is a 7,000-square-metre complex that honours the legend of A-Ma, the Chinese Goddess of Seafarers. This multi-million dollar complex is beautifully designed with traditional architecture. Located en route to Alto de Coloane, the cultural complex comprises the ornate Tin Hau Temple and a stone statue of the goddess A-Ma, the world’s tallest. This is the perfect place to learn more about Macao’s centuries-old link with A-Ma, from which the city is believed to have derived its name.</p>",
            "position": {
                "lat": 22.122707,
                "lng": 113.56326
            },
            "article": "none",
            "slug": "a-ma_cultural_village",
            "photos": {
                "url": "a-ma_cultural_village.jpg"
            }
        },
        {
            "category": "off",
            "name": "Casa Garden and Fundação Oriente",
            "info": "<p>This traditional Portuguese mansion built in 1770 was once the home of a wealthy merchant Manuel Pereira. It was later rented to the East India Company and was used to house the directors of the Macau branch of the company. In 2005, it was listed as part of the UNESCO World Heritage Site Historic Centre of Macao. It’s used as a cultural centre and plays host to art exhibitions and performances of music, film and theatre. The mansion is surrounded by a pleasant, lush garden.</p><h6 class='credits'>(Photo: psgxxx / Shutterstock.com)</h6>",
            "position": {
                "lat": 22.200366,
                "lng": 113.539814
            },
            "article": "none",
            "slug": "casa_garden_and_fundacao_oriente_",
            "photos": {
                "url": "casa_garden_and_fundacao_oriente_.jpg"
            }
        },
        {
            "category": "off",
            "name": "Taipa Village Art Space",
            "info": "<p>Taipa Village Art Space is a house that has been repurposed into an exhibition space. This great little gallery is free to enter and promotes the cultural and creative industries in Macao. It’s a much-needed space for artists to showcase their work. Most exhibitions reflect and give insight into the city’s culture and heritage. It’s conveniently located in Taipa Village, one of the best-preserved areas in the city, where you can also visit a wealth of historic buildings, museums, galleries, restaurants and shops. Macao’s old-time charm and character is still on full display.</p><h6 class='credits'>(Photo: Larcsky / Shutterstock.com)</h6>",
            "position": {
                "lat": 22.152993,
                "lng": 113.556472
            },
            "article": "https://www.scmp.com/special-reports/lifestyle/topics/macau-today/article/2083080/taipa-village-macau-emerges-top-spot",
            "slug": "taipa_village_art_space",
            "photos": {
                "url": "taipa_village_art_space.jpg"
            }
        },
        {
            "category": "off",
            "name": "Patio De Chon Sau",
            "info": "<p>This small, artsy and colourful area located just below the Ruins of St Paul’s is a hive of activity. It’s filled with several specialty and boutique shops selling various handicrafts, as well as friendly eateries serving delicious local snacks. There are contemporary sculptures and art installations placed around the two blocks of the district. It’s well worth having a quick nosey around while exploring the nearby streets of the Historic Centre of Macao.</p><h6 class='credits'>(Photo: Joshua Lee)</h6>",
            "position": {
                "lat": 22.196899,
                "lng": 113.539964
            },
            "article": "none",
            "slug": "patio_de_chon_sau",
            "photos": {
                "url": "patio_de_chon_sau.jpg"
            }
        },
        {
            "category": "off",
            "name": "Macao’s scenic side",
            "info": "<p>Why not try one of the city’s 11 hiking trails that offer a break from the hustle and bustle of the touristy casino areas and enable you to discover Macao’s scenic side. Most of Macao’s hiking and walking trails are located in Coloane, known as the city's green lungs for its rolling hills and forests. The most popular hiking route is the 8-km-long Coloane Hiking Trail that takes hikers up Alto de Coloane. The city has a variety of trails, including the 2.6-km-long Hac Sa Reservoir Family Trail to Hac Sa Beach, a natural beach of black-and-golden sand.</p><h6 class='credits'>(Photo: K.Shun / Shutterstock.com)</h6>",
            "position": {
                "lat": 22.117165,
                "lng": 113.566745
            },
            "article": "https://www.scmp.com/special-reports/lifestyle/topics/macau-today/article/2083076/macaus-hiking-trails-offer-great-escape",
            "slug": "macaos_scenic_side",
            "photos": {
                "url": "macaos_scenic_side.jpg"
            }
        }
    ]
}
